import { apiClient } from "@/api/client";
import { API_ENDPOINTS } from "@/config/app";
import type { PaginatedResponse, PaginationParams } from "@/types/api";
import { buildUrl } from "@/utils/buildUrl";

import type {
  IAssignmentsResponse,
  IAssignmentsUserToRole,
  ICreateUserRole,
  IUserRole,
} from "./types";

export const apiRoleManagement = {
  async getAllUsersRoles(
    params?: PaginationParams
  ): Promise<PaginatedResponse<IUserRole>> {
    const url = buildUrl(API_ENDPOINTS.ADMIN, "/partner-roles", params);

    const response = await apiClient.get<PaginatedResponse<IUserRole>>(url);
    return response;
  },

  async getUserRoleById(id: string): Promise<IUserRole> {
    const response = await apiClient.get<IUserRole>(
      `${API_ENDPOINTS.ADMIN}/partner-roles/${id}`
    );
    return response;
  },

  async patchRoleStatus(id: string, data: { active: boolean }) {
    const response = await apiClient.patch(
      `${API_ENDPOINTS.ADMIN}/partner-roles/${id}`,
      data
    );
    return response;
  },

  async postNewRole(data: ICreateUserRole): Promise<ICreateUserRole> {
    const response = await apiClient.post<ICreateUserRole>(
      `${API_ENDPOINTS.ADMIN}/partner-roles`,
      data
    );
    return response;
  },

  async postNewAssignmentRole(
    data: IAssignmentsUserToRole
  ): Promise<IAssignmentsResponse> {
    const response = await apiClient.post<IAssignmentsResponse>(
      `${API_ENDPOINTS.ADMIN}/partners/assignments/batch`,
      data
    );
    return response;
  },
};
